import L from "leaflet";
import { Marker } from "react-leaflet";
import { VarutsattVeg } from "../../../services/RuteplanAPI";

import varutsattVegIconResource from "../../../assets/weatherProneRoadIcon.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const varutsattVegIcon = L.icon({
    iconUrl: varutsattVegIconResource,
    iconRetinaUrl: varutsattVegIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IVarutsattVegMarkersProps {
    varutsatteVeger: Array<VarutsattVeg>;
}

export default function VarutsattVegMarkers (props: IVarutsattVegMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();
    const { varutsatteVeger } = props;

    return (
        <>
            {varutsatteVeger && varutsatteVeger.map((varutsattVeg: VarutsattVeg, index: number) => {
                return (
                    <Marker key={varutsattVeg.nvdbId + index} 
                    position={[varutsattVeg.location!.y, varutsattVeg.location!.x]} 
                    icon={varutsattVegIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(varutsattVeg);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}